import axios from "axios";

export const read = async (skip,query) => {
    try{
        return axios.get(`${process.env.REACT_APP_BACKEND_URL}/listCompany?skip=${skip}&query=${query}`,{
        })
    } catch(error){
        throw new Error(error);
    }
}